// extracted by mini-css-extract-plugin
module.exports = {"form":"Form-module--form--3UZFL"};